export default __webpack_public_path__ + "static/banner-back-eb12962630d55e8c17e3b7008a8d7771.webp";